import React, {useCallback} from 'react';
import {Title, Text} from '@priority-software/priority-style-react/dist';
import {BooleanButtons} from '../BooleanButtons';
import styles from './styles.module.scss';
import {questionnaireStore} from '../../store/OB_Questionnaire_Store';

export type MainQuestionProps = {
    title: string;
    text?: string;
    onChange: (val: number, ScrLine: number) => void;
    value: number;
    name: string;
    ScrLine: number;
};

export const MainQuestion = ({title, value, name, text, onChange, ScrLine}: MainQuestionProps) => {
    const {handleQuestionnaireMonitoring} = questionnaireStore;

    const onValueChange = useCallback(
        (val: number) => {
            onChange(val, ScrLine);
            handleQuestionnaireMonitoring(val, ScrLine);
        },
        [ScrLine, onChange, handleQuestionnaireMonitoring]
    );

    return (
        <div className={styles.component}>
            <Title skin="h2" textColor="primary-700">
                {title}
            </Title>

            {text && (
                <Text
                    skin="paragraph-1"
                    textColor="primary-700"
                    tag="div"
                    componentClasses={styles.text}
                >
                    <p dangerouslySetInnerHTML={{__html: text}} />
                </Text>
            )}

            <BooleanButtons
                componentCLasses={styles.btns}
                onChange={onValueChange}
                name={name}
                value={value}
            />
        </div>
    );
};
